import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Row,
} from "antd";
import dayjs from "dayjs";
import { useState } from "react";
import { useNavigate } from "react-router";
import SelectProductByClient from "../../../components/SelectProductByClient";
import API from "../../../services/api-request";
import { getDataLogin } from "../../../utils/getDataLogin";

const AddRequestOutbound = () => {
  const navigate = useNavigate();
  const [addForm] = Form.useForm();

  const [loading, setLoading] = useState(false);

  const onSelectProduct = (value, option, index) => {
    addForm.setFieldValue("id", value);
    addForm.setFieldValue(["products", index, "id"], value);
    addForm.setFieldValue(["products", index, "pallet_id"], option?.pallet_id);
    addForm.setFieldValue(
      ["products", index, "product_id"],
      option?.product_id,
    );
    addForm.setFieldValue(["products", index, "name"], option?.name);
    addForm.setFieldValue(
      ["products", index, "weight_requested"],
      option?.weight,
    );
    addForm.setFieldValue(
      ["products", index, "specification"],
      option?.specification,
    );
    addForm.setFieldValue(
      ["products", index, "schedule_at"],
      option?.schedule_at,
    );
    addForm.setFieldValue(["products", index, "qty"], option?.quantity);
  };

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const { schedule_at, products, note } = values;

      let dataForm = {
        schedule_at: dayjs(schedule_at).format("YYYY-MM-DD"),
        products: products.map((e) => {
          return {
            id: e.id,
            product_id: e.product_id,
            pallet_id: e.pallet_id,
            name: e.name,
            specification: e.specification,
            weight: e.weight,
            weight_requested: e.weight_requested,
            schedule_at: e.schedule_at,
            qty: e.qty ?? 0,
          };
        }),
        note: note,
      };

      await API.Post("transaction/outbound/request", dataForm);
      message.success("Request outbound has been added");
      addForm.resetFields();
      handleCancel();
    } catch (err) {
      console.log(err);
      message.info(`${err?.response?.data?.error}`);
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <Form
      form={addForm}
      name="Add Form"
      style={{
        margin: "0 auto",
      }}
      layout="vertical"
      autoComplete="off"
      initialValues={{
        products: [{}], // Memberikan default 1 item kosong
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row gutter={[8, 8]}>
        <Col lg={12} md={12} sm={12} xs={24}>
          <Form.Item
            label="Tanggal Keluar"
            name="schedule_at"
            rules={[
              {
                required: true,
                message: "Please input your tanggal keluar!",
              },
            ]}
          >
            <DatePicker
              style={{ width: "100%" }}
              format="YYYY-MM-DD"
              placeholder="Pilih Tanggal"
              disabledDate={(current) => current <= dayjs().subtract(1, "day")}
            />
          </Form.Item>
        </Col>
        <Col lg={12} md={12} sm={12} xs={24}></Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <Form.Item label="Silahkan Pilih Produk">
            <Form.List name="products">
              {(fields, { add, remove }) => (
                <>
                  {fields.map((field, index) => (
                    <Row key={field.key} gutter={16} align="middle">
                      {/* Jenis Produk */}
                      <Col span={6}>
                        <Form.Item
                          {...field}
                          name={[field.name, "select_product"]}
                          rules={[
                            {
                              required: true,
                              message: "Please input jenis produk!",
                            },
                          ]}
                        >
                          <SelectProductByClient
                            onChange={(value, option) =>
                              onSelectProduct(value, option, index)
                            }
                            client_id={getDataLogin().id}
                          />
                        </Form.Item>
                      </Col>

                      {/* Estimasi Berat */}
                      <Col span={4}>
                        <Form.Item
                          {...field}
                          name={[field.name, "weight_requested"]}
                          rules={[
                            {
                              required: true,
                              message: "Please input estimasi!",
                            },
                          ]}
                        >
                          <InputNumber
                            placeholder="Berat Tersedia"
                            suffix={"Kg"}
                            min={0}
                            controls={false}
                            style={{ width: "100%" }}
                            step={"0.1"}
                          />
                        </Form.Item>
                      </Col>

                      {/* Spesifikasi */}
                      <Col span={5}>
                        <Form.Item
                          {...field}
                          name={[field.name, "specification"]}
                        >
                          <Input placeholder="Spesifikasi" />
                        </Form.Item>
                      </Col>

                      {/* Estimasi Jumlah Pack */}
                      <Col span={3}>
                        <Form.Item {...field} name={[field.name, "qty"]}>
                          <InputNumber
                            placeholder="Jumlah Pack"
                            min={0}
                            controls={false}
                            style={{ width: "100%" }}
                            suffix={"Pack"}
                          />
                        </Form.Item>
                      </Col>

                      {/* Hapus */}
                      <Col span={2}>
                        <Form.Item {...field} name={[field.name, "romove"]}>
                          {index > 0 && (
                            <MinusCircleOutlined
                              style={{
                                fontSize: "20px",
                                color: "red",
                              }}
                              onClick={() => remove(field.name)}
                            />
                          )}
                        </Form.Item>
                      </Col>
                    </Row>
                  ))}
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    icon={<PlusOutlined />}
                    style={{ width: "100%" }}
                  >
                    Tambah Jenis Produk
                  </Button>
                </>
              )}
            </Form.List>
          </Form.Item>
        </Col>
        <Col lg={12} md={12} sm={12} xs={24}>
          <Button
            style={{
              width: "100%",
              backgroundColor: "orange",
              borderColor: "orange",
              color: "white",
            }}
            type="primary"
            onClick={() => handleCancel()}
          >
            Kembali
          </Button>
        </Col>
        <Col lg={12} md={12} sm={12} xs={24}>
          <Button
            key="submit"
            htmlType="submit"
            style={buttonStyle}
            type="primary"
            loading={loading}
          >
            Submit
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

const buttonStyle = {
  width: "100%",
};


AddRequestOutbound.propTypes = {

};

export default AddRequestOutbound;
